import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { configs } from "../app/app-configs";

function Copyright(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" to="https://www.gyminify.com">
                {configs.APP_NAME}
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

export default Copyright;